import React, { useState } from 'react';
import { Share2, Link as LinkIcon, Copy, Check, X } from 'lucide-react';

const ShareSection = ({ modal = false, onClose }) => {
  const [copied, setCopied] = useState(false);
  const backend = (process.env.REACT_APP_BACKEND_URL || 'https://winwithmeditation.com').replace(/\/$/, '');
  // Share-preview URL: hits FastAPI, serves rich OG/Twitter metadata, then
  // redirects humans to the main site. Crawlers (WhatsApp, FB, X, LinkedIn)
  // see the real preview.
  const link = `${backend}/api/share`;

  const doCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_e) { /* ignore */ }
  };

  const platforms = [
    { name: 'WhatsApp', color: 'bg-emerald-500 hover:bg-emerald-600', href: `https://wa.me/?text=${encodeURIComponent('Discover peace with ' + link)}` },
    { name: 'Twitter / X', color: 'bg-black hover:bg-neutral-800', href: `https://twitter.com/intent/tweet?text=${encodeURIComponent('Discover peace with Win With Meditation ' + link)}` },
    { name: 'Facebook', color: 'bg-blue-600 hover:bg-blue-700', href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}` },
    { name: 'Email', color: 'bg-amber-600 hover:bg-amber-700', href: `mailto:?subject=Win With Meditation&body=${encodeURIComponent('I found this peaceful sanctuary: ' + link)}` },
  ];

  const content = (
    <div className={`${modal ? 'w-full max-w-lg' : 'max-w-3xl mx-auto'} rounded-3xl border border-emerald-100 bg-white p-6 sm:p-10 shadow-sm`}>
      <div className="flex items-start justify-between">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-emerald-700"><Share2 className="w-3.5 h-3.5" /> Share Peace</span>
          <h3 className="mt-1 font-serif text-2xl sm:text-3xl text-emerald-950">Share Peace &amp; Calm</h3>
          <p className="mt-1 text-sm text-emerald-900/70">Share winwithmeditation.com with your loved ones.</p>
        </div>
        {modal && (
          <button onClick={onClose} className="p-2 rounded-full hover:bg-emerald-50" aria-label="Close"><X className="w-5 h-5 text-emerald-800" /></button>
        )}
      </div>

      <div className="mt-6">
        <label className="text-xs text-emerald-800 font-medium">Direct Share Link</label>
        <div className="mt-1 flex items-stretch gap-2">
          <div className="flex-1 flex items-center gap-2 px-3 py-2 rounded-lg border border-emerald-200 bg-emerald-50/50 text-sm text-emerald-900">
            <LinkIcon className="w-4 h-4 text-emerald-700" /> {link}
          </div>
          <button onClick={doCopy} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-700 text-white hover:bg-emerald-800">
            {copied ? <><Check className="w-4 h-4" /> Copied</> : <><Copy className="w-4 h-4" /> Copy</>}
          </button>
        </div>
        {copied && <div className="mt-2 text-xs text-emerald-700">Link copied to clipboard!</div>}
      </div>

      <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
        {platforms.map((p) => (
          <a key={p.name} href={p.href} target="_blank" rel="noreferrer" className={`text-center text-white text-sm font-medium rounded-lg px-3 py-3 shadow-sm ${p.color} transition-colors`}>
            {p.name}
          </a>
        ))}
      </div>
    </div>
  );

  if (modal) {
    return (
      <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
        <div onClick={(e) => e.stopPropagation()}>{content}</div>
      </div>
    );
  }
  return (
    <section id="share" className="scroll-mt-24 py-12 sm:py-20">
      <div className="px-4">{content}</div>
    </section>
  );
};

export default ShareSection;
